const state = {
  isLoading: false,
  direction: 'forward',
  user: {
    id: '',
    postName: '',
    userName: '',
    location: '',
    clientCode: ''
  },
  client: {
    code: '',
    name: '',
    expires: null
  },
  mainTitle: '科奥电子'
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js